/**
 * Grade Team visibility (v3.80.0) — ONE predicate for the /reports/grade-team
 * route and the Reports → Grade Team nav entry (the canSeeReports /
 * canSeeSchoolView pattern): flag `gradeTeam` AND the teacher claim AND at
 * least one qualifying building from the session probe
 * (gradeTeamSource.getGradeTeamBuildings). EA-only, TLS and admin tokens
 * never see it; the callable is the real fence, this only decides what
 * renders.
 *
 * `ctx` = { buildings } once the probe resolved, null while it is loading.
 */
import { isFeatureEnabled } from '../constants/featureFlags';

export function canSeeGradeTeam(user, ctx) {
  return isFeatureEnabled('gradeTeam')
    && !!user?.role?.teacher
    && Array.isArray(ctx?.buildings)
    && ctx.buildings.length > 0;
}

/**
 * The route mounts while the probe is still loading (so a reload or deep link
 * does not bounce a qualifying teacher to the dashboard before the answer is
 * in); the page itself redirects once the probe resolves with no building.
 */
export function mayMountGradeTeamRoute(user, ctx) {
  return isFeatureEnabled('gradeTeam')
    && !!user?.role?.teacher
    && (ctx == null || canSeeGradeTeam(user, ctx));
}
